import { z } from 'zod'

export namespace HighlightConfiguration {
  export const Phrase = z.object({
    speaker: z.enum(['Agent', 'Customer', 'Any']),
    phrases: z.array(
      z.object({
        text: z.string(),
        id: z.string().optional(),
        deleted: z.boolean().optional(),
      }),
    ),
    op: z.enum(['eq', 'neq']),
  })

  export type Phrase = z.infer<typeof Phrase>

  export const OccurrenceFilterType = z.enum(['Any', 'First', 'Last'])

  export type OccurrenceFilterType = z.infer<typeof OccurrenceFilterType>
}
